import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './PasswordField.css';

/**
 * Password input with show/hide toggle for auth forms (modal + account pages).
 */
function PasswordField({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
  disabled,
  required,
  className,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) {
  const [show, setShow] = useState(false);
  const inputClassName = ['password-field__input', className].filter(Boolean).join(' ');

  return (
    <div className="password-field">
      <input
        id={id}
        name={name}
        className={inputClassName}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        required={required}
        aria-invalid={ariaInvalid}
        aria-describedby={ariaDescribedBy}
      />
      <button
        type="button"
        className="password-field__toggle"
        onClick={() => setShow((v) => !v)}
        tabIndex={-1}
        aria-label={show ? 'Hide password' : 'Show password'}
        aria-pressed={show}
        disabled={disabled}
      >
        {show ? <FaEyeSlash aria-hidden /> : <FaEye aria-hidden />}
      </button>
    </div>
  );
}

export default PasswordField;
